export const API_URLS = {
    auth: "api/auth",
    pharmacy: "api/pharmacies",
    statereports: "api/statereports",
    createreport: `api/StateReports/Create`,
    getreports: "api/statereports/get",
    statereportedit: "api/statereportedit",
    statesettings: "api/statesettings",
}